import React, { useEffect } from 'react'
import { Card, Flex, ThemeStyleObject } from '../'
import { PropsWithChildren } from 'react'
import { Modal } from './Modal'
import ReactModal from 'react-modal'
import { ModalProvider } from 'react-modal-hook'

export type TiaModalProviderProps = PropsWithChildren<{
    appElement?: string
}>

export const TiaModalProvider = ({
    appElement,
    children
}: TiaModalProviderProps) => {
    const appEl = appElement && document.getElementById(appElement)
    const rootEl = appEl || document.body

    useEffect(() => {
        ReactModal.setAppElement(rootEl || document.body)
    }, [rootEl])

    return <ModalProvider container={rootEl}>{children}</ModalProvider>
}

export const TiaModal = (
    props: PropsWithChildren<{
        sx?: ThemeStyleObject
        shouldCloseOnOverlayClick?: boolean
        isOpen?: boolean
        onRequestClose?(event: React.MouseEvent | React.KeyboardEvent): void
    }>
) => {
    // for backwards compatibility, the default of isOpen is true
    const {
        shouldCloseOnOverlayClick = true,
        isOpen = true,
        onRequestClose
    } = props

    return (
        <Modal
            maxWidth="legacyXs"
            onRequestClose={onRequestClose}
            isOpen={isOpen}
            shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
        >
            <Flex
                sx={{
                    height: '100%',
                    alignItems: 'center',
                    justifyContent: 'center',
                    p: 3
                }}
            >
                <Card sx={{ border: 'none', ...props.sx }}>
                    {props.children}
                </Card>
            </Flex>
        </Modal>
    )
}
